import React, { useEffect, useRef, useState } from 'react';
import MedicalProviderDirectoryService from '../../../../../services/medicalProviderDirectory';
import Autocomplete from 'react-autocomplete';

const SpecialtiesFilter = ({ onFilter, affiliateData, section }) => {
  const [specialities, setSpecialities] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [filterValues, setFilterValues] = useState({ address: null, speciality: null });
  const [addressTyped, setAddressesTyped] = useState('');
  const debounceTimeout = useRef(null);

  useEffect(() => {
    MedicalProviderDirectoryService.getSpecialitiesBySection(section).then((data) =>
      setSpecialities(data),
    );
  }, [section]);

  useEffect(() => {
    if (
      filterValues.address &&
      filterValues.speciality &&
      affiliateData?.afiliado &&
      affiliateData?.isValid
    ) {
      onFilter(filterValues);
    }
  }, [filterValues, affiliateData]);

  const onChangeLocation = async (search) => {
    setAddressesTyped(search);
    if (search.length < 3) {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      setAddresses([]);
      return;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      MedicalProviderDirectoryService.getAddresses(search)
        .then((dataAddress) => setAddresses(dataAddress))
        .catch(() => setAddresses([]));
    }, 1000);
  };

  const getValues = ({ deno_loca, deno_part, deno_prov }) => {
    const arrayLocation = [deno_loca, deno_part, deno_prov?.toUpperCase()].filter((item) => !!item);
    return arrayLocation.join(', ');
  };

  const updateAddress = (value) => {
    if (value === filterValues.address?.deno_part) return;

    const foundAddress = addresses.find((address) => address.id === value) ?? null;
    setFilterValues({ ...filterValues, address: foundAddress });

    if (foundAddress) {
      setAddressesTyped(getValues(foundAddress));
    }
  };

  const onChangeSpeciality = (e) => {
    const { value } = e.target;

    if (value === filterValues.speciality) return;

    setFilterValues({ ...filterValues, speciality: value });
  };

  return (
    <div
      className='row shadow-sm rounded-3 p-5 d-flex justify-content-around'
      style={{ marginBottom: '10px' }}
    >
      <p className='h5 col-12 mb-4'>Elegir especialidad y localidad</p>
      <div className='col-12 col-md-6 pr-md-0' style={{ zIndex: 1 }}>
        <label htmlFor='speciality' className='text-black-50'>
          <strong>Especialidad y estudio</strong>
        </label>
        <select className='form-control rounded-3' onChange={onChangeSpeciality}>
          <option value=''>Seleccionar</option>
          {specialities.map((speciality, index) => (
            <option key={`speciality-${index}`} value={speciality}>
              {speciality}
            </option>
          ))}
        </select>
      </div>
      <div className='col-12 col-md-6 pr-md-0' style={{ zIndex: 1 }}>
        <label className='w-100 text-black-50' htmlFor='address'>
          <strong>Barrio o Localidad</strong>
        </label>
        <div className='position-relative'>
          <Autocomplete
            className='w-100'
            inputProps={{
              type: 'text',
              id: 'address',
              className: 'form-control rounded-3',
              name: 'address',
              placeholder: 'Escribí al menos 3 letras',
            }}
            menuStyle={{
              maxHeight: '150px',
              overflowY: 'auto',
              border: '1px solid #ced4da',
              borderRadius: '0.25rem',
              boxShadow: '0 2px 5px rgba(0, 0, 0, 0.15)',
              position: 'absolute',
              width: '100%',
              left: 0,
              top: '100%',
              zIndex: 1000,
              background: 'white',
            }}
            wrapperProps={{ className: 'w-100 position-relative', style: { width: '100%' } }}
            items={addresses}
            getItemValue={(item) => item.id}
            renderItem={(item, highlighted) => (
              <div
                key={item.id}
                style={{
                  backgroundColor: highlighted ? '#eee' : 'transparent',
                  padding: '5px',
                  cursor: 'pointer',
                }}
              >
                {getValues(item)}
              </div>
            )}
            value={addressTyped}
            onChange={(e) => onChangeLocation(e.target.value)}
            onSelect={(value) => updateAddress(value)}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialtiesFilter;
